/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum TemplateRefKind {
  Pdf = 'pdf',
  Docx = 'docx',
  File = 'file',
}

export enum SyndicationType {
  Zillow = 'zillow',
  Hotpads = 'hotpads',
  Trulia = 'trulia',
  Apartments = 'apartments',
  Rentmor = 'rentmor',
  Realtor = 'realtor',
}

/** SettingsLevel */
export enum SettingsLevel {
  Company = 'company',
  Portfolio = 'portfolio',
  Property = 'property',
  Unit = 'unit',
  Lease = 'lease',
}

export enum RentalApplicationStep {
  Welcome = 'welcome',
  ApplicantInformation = 'applicantInformation',
  PotentialUnits = 'potentialUnits',
  RentalHistory = 'rentalHistory',
  WorkHistory = 'workHistory',
  Pets = 'pets',
  Cars = 'cars',
  Questions = 'questions',
  TermsAndConditions = 'termsAndConditions',
  Payment = 'payment',
  TransUnionScreening = 'transUnionScreening',
  TransUnionQuestions = 'transUnionQuestions',
  ApplicationSubmitted = 'applicationSubmitted',
  ManualVerification = 'manualVerification',
}

export enum RentalApplicationQuestionType {
  Input = 'input',
  Select = 'select',
  MultiSelect = 'multiSelect',
  Boolean = 'boolean',
}

export enum RentalApplicationFileRequirementCondition {
  NotRequired = 'notRequired',
  Always = 'always',
  WhenHasRecords = 'whenHasRecords',
}

export enum RentalApplicationFileKind {
  Other = 'other',
  PayStub = 'payStub',
  GovernmentId = 'governmentId',
  BankStatement = 'bankStatement',
  TaxReturn = 'taxReturn',
  OfferLetter = 'offerLetter',
  ReferenceLetter = 'referenceLetter',
  EmploymentVerification = 'employmentVerification',
}

export enum MinimumPaymentType {
  Fixed = 'fixed',
  Percent = 'percent',
  PercentOrMinimum = 'percentOrMinimum',
}

export enum ManagementFeeType {
  Fixed = 'fixed',
  Percentage = 'percentage',
}

export enum LateFeeFrequency {
  Once = 'once',
  Daily = 'daily',
  Monthly = 'monthly',
}

export enum LateFeeCalculation {
  Fixed = 'fixed',
  Percent = 'percent',
  PercentOrMinimum = 'percentOrMinimum',
  Formula = 'formula',
}

/** CustomViewType */
export enum CustomViewType {
  Units = 'units',
  Properties = 'properties',
  Leases = 'leases',
  LeasesWithBalanceDue = 'leasesWithBalanceDue',
  DraftLeases = 'draftLeases',
  ExpiringLeases = 'expiringLeases',
  PastLeases = 'pastLeases',
  LeasesWithMoveOutRequests = 'leasesWithMoveOutRequests',
  LeaseRentalApplications = 'leaseRentalApplications',
  PropertyApplications = 'propertyApplications',
  AccountingBills = 'accountingBills',
  MaintenanceRequests = 'maintenanceRequests',
  WorkOrders = 'workOrders',
  WorkOrderBills = 'workOrderBills',
  PropertyManagers = 'propertyManagers',
  Owners = 'owners',
  Tenants = 'tenants',
}

export enum ColumnType {
  System = 'system',
  Custom = 'custom',
}

export enum AutoPayIncentiveType {
  None = 'none',
  Credit = 'credit',
}

export enum AssociationViolationLeaseCharge {
  NoCharge = 'noCharge',
  AssociationViolationFee = 'associationViolationFee',
  AssociationViolationFeePlusPropertyManagerFee = 'associationViolationFeePlusPropertyManagerFee',
  FixedAmount = 'fixedAmount',
}

export interface ACHPaymentProcessingSettings {
  allowHighRiskAch: boolean;
}

export interface ACHPaymentProcessingSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ACHPaymentProcessingSettings;
}

export interface ACHPaymentProcessingSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ACHPaymentProcessingSettings;
  targets: OverrideTargetDto[];
}

export interface ACHPaymentProcessingSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ACHPaymentProcessingSettings;
  overrides: ACHPaymentProcessingSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ACHPaymentProcessingSettingsTypedSettingsOverrideEntryDocument {
  settings: ACHPaymentProcessingSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface AgentsChatSettings {
  useV2: boolean;
  enableLeaseAi: boolean;
  enableTenantAi: boolean;
  enableMaintenanceRequestAi: boolean;
  enableWorkOrderAi: boolean;
  enableWorkOrderGroupAi: boolean;
  enableVendorAi: boolean;
  enableOwnerAi: boolean;
  enableUnknownAi: boolean;
}

export interface AgentsChatSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: AgentsChatSettings;
}

export interface AgentsChatSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: AgentsChatSettings;
  targets: OverrideTargetDto[];
}

export interface AgentsChatSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: AgentsChatSettings;
  overrides: AgentsChatSettingsTypedSettingsOverrideEntryDocument[];
}

export interface AgentsChatSettingsTypedSettingsOverrideEntryDocument {
  settings: AgentsChatSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface AssociationViolationSettings {
  /** @format int64 */
  associationViolationFeeChartOfAccountId: string;
  /** @format int64 */
  associationViolationFeeRetrievalChartOfAccountId: string;
  associationViolationLeaseCharge: AssociationViolationLeaseCharge;
  /** @format double */
  associationViolationLeaseChargeAmount: number;
}

export interface AssociationViolationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: AssociationViolationSettings;
}

export interface AssociationViolationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: AssociationViolationSettings;
  targets: OverrideTargetDto[];
}

export interface AssociationViolationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: AssociationViolationSettings;
  overrides: AssociationViolationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface AssociationViolationSettingsTypedSettingsOverrideEntryDocument {
  settings: AssociationViolationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface AutoPayIncentivesSettings {
  incentiveType: AutoPayIncentiveType;
  /** @format double */
  minimalPayment: number;
  /** @format int32 */
  maxIncentivePerMonth: number;
  /** @format double */
  creditAmount: number;
  /**
   * @minLength 0
   * @maxLength 250
   */
  creditDescription: string;
}

export interface AutoPayIncentivesSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: AutoPayIncentivesSettings;
}

export interface AutoPayIncentivesSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: AutoPayIncentivesSettings;
  targets: OverrideTargetDto[];
}

export interface AutoPayIncentivesSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: AutoPayIncentivesSettings;
  overrides: AutoPayIncentivesSettingsTypedSettingsOverrideEntryDocument[];
}

export interface AutoPayIncentivesSettingsTypedSettingsOverrideEntryDocument {
  settings: AutoPayIncentivesSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ChargeNotificationSettings {
  sendChargeNotification: boolean;
  sendChargeNotificationManuallyAdded: boolean;
  sendChargeNotificationSystemAdded: boolean;
  sendSetupAutoPayAsPartOfNotification: boolean;
  sendChargeNotificationAsText: boolean;
  sendChargeNotificationAsEmail: boolean;
}

export interface ChargeNotificationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ChargeNotificationSettings;
}

export interface ChargeNotificationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ChargeNotificationSettings;
  targets: OverrideTargetDto[];
}

export interface ChargeNotificationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ChargeNotificationSettings;
  overrides: ChargeNotificationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ChargeNotificationSettingsTypedSettingsOverrideEntryDocument {
  settings: ChargeNotificationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ChatAILeaseRenewalSettings {
  enabled: boolean;
  additionalInstructions: string;
  renewalPolicies?: ChatAiRenewalPolicies;
}

export interface ChatAILeaseRenewalSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ChatAILeaseRenewalSettings;
}

export interface ChatAILeaseRenewalSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ChatAILeaseRenewalSettings;
  targets: OverrideTargetDto[];
}

export interface ChatAILeaseRenewalSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ChatAILeaseRenewalSettings;
  overrides: ChatAILeaseRenewalSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ChatAILeaseRenewalSettingsTypedSettingsOverrideEntryDocument {
  settings: ChatAILeaseRenewalSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ChatAILeaseRentersInsuranceSettings {
  enabled: boolean;
  additionalInstructions: string;
}

export interface ChatAILeaseRentersInsuranceSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ChatAILeaseRentersInsuranceSettings;
}

export interface ChatAILeaseRentersInsuranceSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ChatAILeaseRentersInsuranceSettings;
  targets: OverrideTargetDto[];
}

export interface ChatAILeaseRentersInsuranceSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ChatAILeaseRentersInsuranceSettings;
  overrides: ChatAILeaseRentersInsuranceSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ChatAILeaseRentersInsuranceSettingsTypedSettingsOverrideEntryDocument {
  settings: ChatAILeaseRentersInsuranceSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ChatAILeaseSettings {
  enabled: boolean;
  additionalInstructions: string;
}

export interface ChatAILeaseSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ChatAILeaseSettings;
}

export interface ChatAILeaseSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ChatAILeaseSettings;
  targets: OverrideTargetDto[];
}

export interface ChatAILeaseSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ChatAILeaseSettings;
  overrides: ChatAILeaseSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ChatAILeaseSettingsTypedSettingsOverrideEntryDocument {
  settings: ChatAILeaseSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ChatAIMaintenanceRequestsSettings {
  enabled: boolean;
  additionalInstructions: string;
}

export interface ChatAIMaintenanceRequestsSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ChatAIMaintenanceRequestsSettings;
}

export interface ChatAIMaintenanceRequestsSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ChatAIMaintenanceRequestsSettings;
  targets: OverrideTargetDto[];
}

export interface ChatAIMaintenanceRequestsSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ChatAIMaintenanceRequestsSettings;
  overrides: ChatAIMaintenanceRequestsSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ChatAIMaintenanceRequestsSettingsTypedSettingsOverrideEntryDocument {
  settings: ChatAIMaintenanceRequestsSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ChatAISettings {
  enabled: boolean;
}

export interface ChatAISettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ChatAISettings;
}

export interface ChatAISettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ChatAISettings;
  targets: OverrideTargetDto[];
}

export interface ChatAISettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ChatAISettings;
  overrides: ChatAISettingsTypedSettingsOverrideEntryDocument[];
}

export interface ChatAISettingsTypedSettingsOverrideEntryDocument {
  settings: ChatAISettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ChatAITranslationSettings {
  enabled: boolean;
  additionalInstructions: string;
}

export interface ChatAITranslationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ChatAITranslationSettings;
}

export interface ChatAITranslationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ChatAITranslationSettings;
  targets: OverrideTargetDto[];
}

export interface ChatAITranslationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ChatAITranslationSettings;
  overrides: ChatAITranslationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ChatAITranslationSettingsTypedSettingsOverrideEntryDocument {
  settings: ChatAITranslationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ChatAiRenewalPolicies {
  noticeRequirement?: string;
  rentIncreasePolicy?: string;
  leaseTermOptions?: string;
  monthToMonthPolicy?: string;
  renewalTimeline?: string;
  additionalTerms?: string;
}

export interface ChatSettings {
  enabled: boolean;
  personalChats: boolean;
  enableTranslation: boolean;
  enableQuietHours: boolean;
  quietHours?: TimeRange;
  setAIMessagesAsUnread: boolean;
}

export interface ChatSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ChatSettings;
}

export interface ChatSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ChatSettings;
  targets: OverrideTargetDto[];
}

export interface ChatSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ChatSettings;
  overrides: ChatSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ChatSettingsTypedSettingsOverrideEntryDocument {
  settings: ChatSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface CommunicationsSettings {
  disableAllCommunications: boolean;
}

export interface CommunicationsSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: CommunicationsSettings;
}

export interface CommunicationsSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: CommunicationsSettings;
  targets: OverrideTargetDto[];
}

export interface CommunicationsSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: CommunicationsSettings;
  overrides: CommunicationsSettingsTypedSettingsOverrideEntryDocument[];
}

export interface CommunicationsSettingsTypedSettingsOverrideEntryDocument {
  settings: CommunicationsSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface CompanyPortalEntityMetadataDocument {
  level: SettingsLevel;
  levelId: string;
  groupId?: string;
}

export interface CompanyPortalResolvedMetadataDocument {
  source?: SettingsLevel;
  sourceId?: string;
  isDefault: boolean;
}

export interface CompanySettings {
  /** @format int64 */
  subscriptionChartOfAccountId: string;
  /** @format int64 */
  elevioAccountId?: string;
  /** @format int64 */
  stripeAccountId?: string;
  /** @format int64 */
  sureAccountId?: string;
  /** @format int64 */
  payabliAccountId?: string;
  /** @format int64 */
  plaidAccountId?: string;
  workHours?: TimeRange;
  /** @format int64 */
  invoiceBankAccountId?: string;
  /** @format int64 */
  invoiceCashChartOfAccountId?: string;
  /** @format int64 */
  invoicePaymentMethodId?: string;
  /** @format int64 */
  invoicePaymentAccountId?: string;
}

export interface CompanySettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: CompanySettings;
}

export interface CompanySettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: CompanySettings;
  targets: OverrideTargetDto[];
}

export interface CompanySettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: CompanySettings;
  overrides: CompanySettingsTypedSettingsOverrideEntryDocument[];
}

export interface CompanySettingsTypedSettingsOverrideEntryDocument {
  settings: CompanySettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ContributionSettings {
  /** @format int64 */
  contributionChartOfAccountId: string;
  allowOnlinePayments: boolean;
}

export interface ContributionSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ContributionSettings;
}

export interface ContributionSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ContributionSettings;
  targets: OverrideTargetDto[];
}

export interface ContributionSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ContributionSettings;
  overrides: ContributionSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ContributionSettingsTypedSettingsOverrideEntryDocument {
  settings: ContributionSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

/** CreateCustomViewDto */
export interface CreateCustomViewDto {
  /** @minLength 1 */
  name: string;
  favorite: boolean;
  columns: CreateViewColumnDto[];
  description?: string;
}

/** CreatePortalInviteTemplateDto */
export interface CreatePortalInviteTemplateDto {
  /** @minLength 1 */
  name: string;
  email: PortalInviteTemplateEmailDto;
  text: PortalInviteTemplateTextDto;
}

/** CreateViewColumnDto */
export interface CreateViewColumnDto {
  /** @minLength 1 */
  key: string;
  /** @minLength 1 */
  type: string;
  selected: boolean;
  /** @format int32 */
  displayOrder?: number;
  /** @format int32 */
  width?: number;
  customFieldId?: string;
  description?: string;
}

export interface CustomView {
  key: string;
  name: string;
  columns: ViewColumn[];
  viewType: CustomViewType;
  favorite: boolean;
  description?: string;
}

/** CustomViewDto */
export interface CustomViewDto {
  id: string;
  key: string;
  name: string;
  viewType: string;
  favorite: boolean;
  columns: ViewColumnDto[];
  description?: string;
}

export interface CustomViewSettings {
  enabled: boolean;
  customViews: CustomView[];
}

export interface CustomViewSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: CustomViewSettings;
}

export interface CustomViewSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: CustomViewSettings;
  targets: OverrideTargetDto[];
}

export interface CustomViewSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: CustomViewSettings;
  overrides: CustomViewSettingsTypedSettingsOverrideEntryDocument[];
}

export interface CustomViewSettingsTypedSettingsOverrideEntryDocument {
  settings: CustomViewSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface DepositPaymentSettings {
  /** @format int64 */
  bankAccountId?: string;
  /** @format int64 */
  cashChartOfAccountId?: string;
  allowOnlinePayments: boolean;
  allowAchPayments: boolean;
  allowCardPayments: boolean;
  allowPartialPayments: boolean;
  minimumPaymentType: MinimumPaymentType;
  /** @format double */
  minimumPaymentPercent: number;
  /** @format double */
  minimumPaymentAmount: number;
}

export interface DepositPaymentSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: DepositPaymentSettings;
}

export interface DepositPaymentSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: DepositPaymentSettings;
  targets: OverrideTargetDto[];
}

export interface DepositPaymentSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: DepositPaymentSettings;
  overrides: DepositPaymentSettingsTypedSettingsOverrideEntryDocument[];
}

export interface DepositPaymentSettingsTypedSettingsOverrideEntryDocument {
  settings: DepositPaymentSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface DistributionSettings {
  /** @format int64 */
  distributionChartOfAccountId: string;
}

export interface DistributionSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: DistributionSettings;
}

export interface DistributionSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: DistributionSettings;
  targets: OverrideTargetDto[];
}

export interface DistributionSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: DistributionSettings;
  overrides: DistributionSettingsTypedSettingsOverrideEntryDocument[];
}

export interface DistributionSettingsTypedSettingsOverrideEntryDocument {
  settings: DistributionSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface EmailSettings {
  enableEmails: boolean;
}

export interface EmailSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: EmailSettings;
}

export interface EmailSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: EmailSettings;
  targets: OverrideTargetDto[];
}

export interface EmailSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: EmailSettings;
  overrides: EmailSettingsTypedSettingsOverrideEntryDocument[];
}

export interface EmailSettingsTypedSettingsOverrideEntryDocument {
  settings: EmailSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface GeneralAnswer {
  text?: string;
  isSelected: boolean;
  isFreeformInput: boolean;
  followUpQuestions?: GeneralQuestion[];
}

export interface GeneralQuestion {
  text: string;
  isRequired: boolean;
  isMultiSelect: boolean;
  answers?: GeneralAnswer[];
}

/** JsonNode */
export interface JsonNode {
  options?: JsonNodeOptions;
  parent?: JsonNode;
  root: JsonNode;
}

/** JsonNodeOptions */
export interface JsonNodeOptions {
  propertyNameCaseInsensitive: boolean;
}

/** LateFeeFormulaTestDto */
export interface LateFeeFormulaTestDto {
  /**
   * @minLength 1
   * @pattern .*\S.*
   */
  formula: string;
  /**
   * @format double
   * @min 0
   * @max 7.922816251426434e+28
   */
  due: number;
  /**
   * @format double
   * @min 0
   * @max 7.922816251426434e+28
   */
  total: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  lateBills: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  lateDays: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  gracePeriod: number;
  /**
   * @format double
   * @min 0
   * @max 7.922816251426434e+28
   */
  graceBalance: number;
}

/** LateFeeFormulaTestResultDto */
export interface LateFeeFormulaTestResultDto {
  /** @format double */
  result: number;
}

export interface LateFeesSettings {
  enabled: boolean;
  /** @format int32 */
  gracePeriod: number;
  /** @format double */
  graceBalance: number;
  calculation: LateFeeCalculation;
  /** @format double */
  amount: number;
  /** @format double */
  feePercent: number;
  /** @format int64 */
  lateFeeChartOfAccountId: string;
  /**
   * @minLength 0
   * @maxLength 500
   */
  lateFeeDescription: string;
  lateFeeIncludeChartOfAccountIds?: string[];
  lateFeePreventChartOfAccountIds?: string[];
  lateFeeIsCompanyBill: boolean;
  formula?: string;
  frequency: LateFeeFrequency;
}

export interface LateFeesSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: LateFeesSettings;
}

export interface LateFeesSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: LateFeesSettings;
  targets: OverrideTargetDto[];
}

export interface LateFeesSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: LateFeesSettings;
  overrides: LateFeesSettingsTypedSettingsOverrideEntryDocument[];
}

export interface LateFeesSettingsTypedSettingsOverrideEntryDocument {
  settings: LateFeesSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface LeaseChartOfAccountSettings {
  rentChartOfAccountIds?: string[];
  /** @format int64 */
  defaultSecurityDepositChartOfAccountId: string;
  /** @format int64 */
  defaultRentChartOfAccountId: string;
}

export interface LeaseChartOfAccountSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: LeaseChartOfAccountSettings;
}

export interface LeaseChartOfAccountSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: LeaseChartOfAccountSettings;
  targets: OverrideTargetDto[];
}

export interface LeaseChartOfAccountSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: LeaseChartOfAccountSettings;
  overrides: LeaseChartOfAccountSettingsTypedSettingsOverrideEntryDocument[];
}

export interface LeaseChartOfAccountSettingsTypedSettingsOverrideEntryDocument {
  settings: LeaseChartOfAccountSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface LeaseInvoiceSettings {
  sendRecurringChargeInvoiceEmail: boolean;
}

export interface LeaseInvoiceSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: LeaseInvoiceSettings;
}

export interface LeaseInvoiceSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: LeaseInvoiceSettings;
  targets: OverrideTargetDto[];
}

export interface LeaseInvoiceSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: LeaseInvoiceSettings;
  overrides: LeaseInvoiceSettingsTypedSettingsOverrideEntryDocument[];
}

export interface LeaseInvoiceSettingsTypedSettingsOverrideEntryDocument {
  settings: LeaseInvoiceSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface LeaseRenewalSettings {
  /** @format double */
  rentIncrease: number;
  rentChartOfAccounts: string[];
  sendTenantNotifyOnRenewal: boolean;
  templates: TemplateRef[];
}

export interface LeaseRenewalSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: LeaseRenewalSettings;
}

export interface LeaseRenewalSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: LeaseRenewalSettings;
  targets: OverrideTargetDto[];
}

export interface LeaseRenewalSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: LeaseRenewalSettings;
  overrides: LeaseRenewalSettingsTypedSettingsOverrideEntryDocument[];
}

export interface LeaseRenewalSettingsTypedSettingsOverrideEntryDocument {
  settings: LeaseRenewalSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface LeaseRentersInsuranceSettings {
  reminderEnabled: boolean;
  /** @format int32 */
  daysBeforeLeaseStartToNotify: number;
  /** @format int32 */
  daysAfterLeaseStartToNotify: number;
  /** @format int32 */
  daysBetweenReminders: number;
  /** @format int32 */
  maxReminders: number;
  sendEmail: boolean;
  sendText: boolean;
  notifyPropertyManager: boolean;
  blockTenantPortalAccess: boolean;
}

export interface LeaseRentersInsuranceSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: LeaseRentersInsuranceSettings;
}

export interface LeaseRentersInsuranceSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: LeaseRentersInsuranceSettings;
  targets: OverrideTargetDto[];
}

export interface LeaseRentersInsuranceSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: LeaseRentersInsuranceSettings;
  overrides: LeaseRentersInsuranceSettingsTypedSettingsOverrideEntryDocument[];
}

export interface LeaseRentersInsuranceSettingsTypedSettingsOverrideEntryDocument {
  settings: LeaseRentersInsuranceSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface MaintenanceRequestRunBookSettings {
  enableRunBook: boolean;
  /** @format int64 */
  defaultPropertyManagerId?: string;
}

export interface MaintenanceRequestRunBookSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: MaintenanceRequestRunBookSettings;
}

export interface MaintenanceRequestRunBookSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: MaintenanceRequestRunBookSettings;
  targets: OverrideTargetDto[];
}

export interface MaintenanceRequestRunBookSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: MaintenanceRequestRunBookSettings;
  overrides: MaintenanceRequestRunBookSettingsTypedSettingsOverrideEntryDocument[];
}

export interface MaintenanceRequestRunBookSettingsTypedSettingsOverrideEntryDocument {
  settings: MaintenanceRequestRunBookSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface MaintenanceRequestSettings {
  allowTenantToClose: boolean;
  onlyAllowRequesterToClose: boolean;
  allowTenantToEdit: boolean;
  onlyAllowRequesterToEdit: boolean;
  /** @format int32 */
  recentRequestsDays: number;
}

export interface MaintenanceRequestSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: MaintenanceRequestSettings;
}

export interface MaintenanceRequestSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: MaintenanceRequestSettings;
  targets: OverrideTargetDto[];
}

export interface MaintenanceRequestSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: MaintenanceRequestSettings;
  overrides: MaintenanceRequestSettingsTypedSettingsOverrideEntryDocument[];
}

export interface MaintenanceRequestSettingsTypedSettingsOverrideEntryDocument {
  settings: MaintenanceRequestSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface ManagementFeeSettings {
  ignoreChartOfAccounts: string[];
  includeChartOfAccounts: string[];
  feeType: ManagementFeeType;
  /** @format double */
  feePercentage: number;
  /** @format double */
  minimumFee: number;
  /** @format double */
  maximumFee?: number;
  applyMinimumFeeWhenNoRevenue: boolean;
  /** @format int64 */
  managementFeePropertyChartOfAccountId: string;
  /** @format int64 */
  managementFeeCompanyChartOfAccountId: string;
  /** @format int32 */
  lookbackMonths: number;
}

export interface ManagementFeeSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: ManagementFeeSettings;
}

export interface ManagementFeeSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: ManagementFeeSettings;
  targets: OverrideTargetDto[];
}

export interface ManagementFeeSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: ManagementFeeSettings;
  overrides: ManagementFeeSettingsTypedSettingsOverrideEntryDocument[];
}

export interface ManagementFeeSettingsTypedSettingsOverrideEntryDocument {
  settings: ManagementFeeSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface OutgoingPaymentsSettings {
  /** @format int64 */
  processingFeesChartOfAccountId: string;
}

export interface OutgoingPaymentsSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: OutgoingPaymentsSettings;
}

export interface OutgoingPaymentsSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: OutgoingPaymentsSettings;
  targets: OverrideTargetDto[];
}

export interface OutgoingPaymentsSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: OutgoingPaymentsSettings;
  overrides: OutgoingPaymentsSettingsTypedSettingsOverrideEntryDocument[];
}

export interface OutgoingPaymentsSettingsTypedSettingsOverrideEntryDocument {
  settings: OutgoingPaymentsSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

/** OverrideTargetDto */
export interface OverrideTargetDto {
  level: SettingsLevel;
  levelId: string;
}

/** PortalInviteMergeFieldDto */
export interface PortalInviteMergeFieldDto {
  token: string;
  label: string;
}

/** PortalInviteTemplateDto */
export interface PortalInviteTemplateDto {
  id: string;
  kind: string;
  name: string;
  isCustom: boolean;
  email: PortalInviteTemplateEmailDto;
  text: PortalInviteTemplateTextDto;
  updatedAt: string;
  updatedByName?: string;
}

/** PortalInviteTemplateEmailDto */
export interface PortalInviteTemplateEmailDto {
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  body: string;
}

/** PortalInviteTemplateTextDto */
export interface PortalInviteTemplateTextDto {
  /** @minLength 1 */
  body: string;
}

export interface PropertyManagerNotificationSettings {
  sendNotifyOnPaymentFailure: boolean;
  sendNotifyOnPaymentReturned: boolean;
}

export interface PropertyManagerNotificationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: PropertyManagerNotificationSettings;
}

export interface PropertyManagerNotificationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: PropertyManagerNotificationSettings;
  targets: OverrideTargetDto[];
}

export interface PropertyManagerNotificationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: PropertyManagerNotificationSettings;
  overrides: PropertyManagerNotificationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface PropertyManagerNotificationSettingsTypedSettingsOverrideEntryDocument {
  settings: PropertyManagerNotificationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface PropertySettings {
  /** @format double */
  reserve: number;
  /** @format double */
  ownerApprovalLimit?: number;
  /** @format double */
  vendorApprovalLimit?: number;
}

export interface PropertySettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: PropertySettings;
}

export interface PropertySettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: PropertySettings;
  targets: OverrideTargetDto[];
}

export interface PropertySettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: PropertySettings;
  overrides: PropertySettingsTypedSettingsOverrideEntryDocument[];
}

export interface PropertySettingsTypedSettingsOverrideEntryDocument {
  settings: PropertySettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentPaymentFailureFeeSettings {
  chargeFeeForFailedTransfers: boolean;
  /** @format int64 */
  noSufficientFundsFeeChargeChartOfAccountId: string;
  /** @format double */
  noSufficientFundsFee: number;
  /** @format double */
  achFailedFee: number;
  /** @format int64 */
  achReturnFeeChartOfAccountId: string;
  /** @format double */
  achReturnFee: number;
  /** @format int64 */
  achFailedProcessingFeeChartOfAccountId: string;
  /** @format int64 */
  achFailedCompanyChargeChartOfAccountId: string;
  /** @format int64 */
  disputeFeeChartOfAccountId: string;
  /** @format int64 */
  propertyManagerPaysDisputeFeeChartOfAccountId: string;
  /** @format double */
  disputeFee: number;
}

export interface RentPaymentFailureFeeSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentPaymentFailureFeeSettings;
}

export interface RentPaymentFailureFeeSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentPaymentFailureFeeSettings;
  targets: OverrideTargetDto[];
}

export interface RentPaymentFailureFeeSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentPaymentFailureFeeSettings;
  overrides: RentPaymentFailureFeeSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentPaymentFailureFeeSettingsTypedSettingsOverrideEntryDocument {
  settings: RentPaymentFailureFeeSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentPaymentNotificationSettings {
  sendRentReceivedNotifications: boolean;
  sendRentReceivedNotificationAsText: boolean;
  sendRentReceivedNotificationAsEmail: boolean;
  ignoreManualPaymentNotifications: boolean;
}

export interface RentPaymentNotificationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentPaymentNotificationSettings;
}

export interface RentPaymentNotificationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentPaymentNotificationSettings;
  targets: OverrideTargetDto[];
}

export interface RentPaymentNotificationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentPaymentNotificationSettings;
  overrides: RentPaymentNotificationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentPaymentNotificationSettingsTypedSettingsOverrideEntryDocument {
  settings: RentPaymentNotificationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentPaymentProcessingFeesSettings {
  /** @format int64 */
  leaseProcessingFeesChartOfAccountId: string;
  propertyManagerPaysProcessingFees: boolean;
  /** @format int64 */
  propertyManagerPaysProcessingFeesChartOfAccountId: string;
  /** @format double */
  propertyManagerProcessingFee: number;
}

export interface RentPaymentProcessingFeesSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentPaymentProcessingFeesSettings;
}

export interface RentPaymentProcessingFeesSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentPaymentProcessingFeesSettings;
  targets: OverrideTargetDto[];
}

export interface RentPaymentProcessingFeesSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentPaymentProcessingFeesSettings;
  overrides: RentPaymentProcessingFeesSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentPaymentProcessingFeesSettingsTypedSettingsOverrideEntryDocument {
  settings: RentPaymentProcessingFeesSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentPaymentSettings {
  /** @format int64 */
  bankAccountId?: string;
  /** @format int64 */
  cashChartOfAccountId?: string;
  allowOnlinePayments: boolean;
  allowAchPayments: boolean;
  allowCardPayments: boolean;
  allowZellePayments: boolean;
  /** @format int32 */
  postBillsDaysBeforeDue: number;
  allowPartialPayments: boolean;
  minimumPaymentType: MinimumPaymentType;
  /** @format double */
  minimumPaymentPercent: number;
  /** @format double */
  minimumPaymentAmount: number;
}

export interface RentPaymentSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentPaymentSettings;
}

export interface RentPaymentSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentPaymentSettings;
  targets: OverrideTargetDto[];
}

export interface RentPaymentSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentPaymentSettings;
  overrides: RentPaymentSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentPaymentSettingsTypedSettingsOverrideEntryDocument {
  settings: RentPaymentSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentalApplicationBillingSettings {
  requirePaymentForApplication: boolean;
  /** @format double */
  applicationFee: number;
  propertyManagerPaysProcessingFees: boolean;
  /** @format int64 */
  bankAccountId?: string;
  /** @format int64 */
  cashChartOfAccountId?: string;
  /** @format int64 */
  rentalApplicationChartOfAccountId: string;
  /** @format int64 */
  creditReportChartOfAccountId: string;
  /** @format int64 */
  disputeFeeChartOfAccountId: string;
}

export interface RentalApplicationBillingSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentalApplicationBillingSettings;
}

export interface RentalApplicationBillingSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentalApplicationBillingSettings;
  targets: OverrideTargetDto[];
}

export interface RentalApplicationBillingSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentalApplicationBillingSettings;
  overrides: RentalApplicationBillingSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentalApplicationBillingSettingsTypedSettingsOverrideEntryDocument {
  settings: RentalApplicationBillingSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentalApplicationChartOfAccountSettings {
  /** @format int64 */
  rentalApplicationChartOfAccountId: string;
  /** @format int64 */
  creditReportChartOfAccountId: string;
  /** @format int64 */
  disputeFeeChartOfAccountId: string;
}

export interface RentalApplicationChartOfAccountSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentalApplicationChartOfAccountSettings;
}

export interface RentalApplicationChartOfAccountSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentalApplicationChartOfAccountSettings;
  targets: OverrideTargetDto[];
}

export interface RentalApplicationChartOfAccountSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentalApplicationChartOfAccountSettings;
  overrides: RentalApplicationChartOfAccountSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentalApplicationChartOfAccountSettingsTypedSettingsOverrideEntryDocument {
  settings: RentalApplicationChartOfAccountSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentalApplicationFileRequirement {
  label: string;
  description?: string;
  step?: RentalApplicationStep;
  requiredWhen: RentalApplicationFileRequirementCondition;
  required?: boolean;
  multiple: boolean;
  kind?: RentalApplicationFileKind;
}

export interface RentalApplicationGeneralSettings {
  welcomeMessage?: string;
  requireSSN: boolean;
  requireScreeningForApplication: boolean;
  /** @format int32 */
  rentalApplicationRecencyInDays: number;
  /** @format int32 */
  draftReminderDays?: number;
  fileRequirements: RentalApplicationFileRequirement[];
  disableSteps?: RentalApplicationStep[];
}

export interface RentalApplicationGeneralSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentalApplicationGeneralSettings;
}

export interface RentalApplicationGeneralSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentalApplicationGeneralSettings;
  targets: OverrideTargetDto[];
}

export interface RentalApplicationGeneralSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentalApplicationGeneralSettings;
  overrides: RentalApplicationGeneralSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentalApplicationGeneralSettingsTypedSettingsOverrideEntryDocument {
  settings: RentalApplicationGeneralSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentalApplicationPaymentAccountSettings {
  /** @format int64 */
  bankAccountId?: string;
  /** @format int64 */
  cashChartOfAccountId?: string;
}

export interface RentalApplicationPaymentAccountSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentalApplicationPaymentAccountSettings;
}

export interface RentalApplicationPaymentAccountSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentalApplicationPaymentAccountSettings;
  targets: OverrideTargetDto[];
}

export interface RentalApplicationPaymentAccountSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentalApplicationPaymentAccountSettings;
  overrides: RentalApplicationPaymentAccountSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentalApplicationPaymentAccountSettingsTypedSettingsOverrideEntryDocument {
  settings: RentalApplicationPaymentAccountSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentalApplicationPaymentSettings {
  requirePaymentForApplication: boolean;
  /** @format double */
  applicationFee: number;
  propertyManagerPaysProcessingFees: boolean;
}

export interface RentalApplicationPaymentSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentalApplicationPaymentSettings;
}

export interface RentalApplicationPaymentSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentalApplicationPaymentSettings;
  targets: OverrideTargetDto[];
}

export interface RentalApplicationPaymentSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentalApplicationPaymentSettings;
  overrides: RentalApplicationPaymentSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentalApplicationPaymentSettingsTypedSettingsOverrideEntryDocument {
  settings: RentalApplicationPaymentSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentalApplicationQuestion {
  text: string;
  type: RentalApplicationQuestionType;
  options?: string[];
}

export interface RentalApplicationQuestionnaireSettings {
  applicationQuestions: {
    general?: GeneralQuestion[];
    employment?: GeneralQuestion[];
  };
}

export interface RentalApplicationQuestionnaireSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentalApplicationQuestionnaireSettings;
}

export interface RentalApplicationQuestionnaireSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentalApplicationQuestionnaireSettings;
  targets: OverrideTargetDto[];
}

export interface RentalApplicationQuestionnaireSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentalApplicationQuestionnaireSettings;
  overrides: RentalApplicationQuestionnaireSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentalApplicationQuestionnaireSettingsTypedSettingsOverrideEntryDocument {
  settings: RentalApplicationQuestionnaireSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentalApplicationScreeningSettings {
  requireScreeningForApplication: boolean;
}

export interface RentalApplicationScreeningSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentalApplicationScreeningSettings;
}

export interface RentalApplicationScreeningSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentalApplicationScreeningSettings;
  targets: OverrideTargetDto[];
}

export interface RentalApplicationScreeningSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentalApplicationScreeningSettings;
  overrides: RentalApplicationScreeningSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentalApplicationScreeningSettingsTypedSettingsOverrideEntryDocument {
  settings: RentalApplicationScreeningSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface RentalApplicationSettings {
  welcomeMessage?: string;
  requireSSN: boolean;
  /** @format int32 */
  rentalApplicationRecencyInDays: number;
  /** @format int32 */
  draftReminderDays?: number;
  questions: RentalApplicationQuestion[];
  fileRequirements: RentalApplicationFileRequirement[];
  applicationQuestions: {
    general?: GeneralQuestion[];
    employment?: GeneralQuestion[];
  };
  disableSteps?: RentalApplicationStep[];
}

export interface RentalApplicationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: RentalApplicationSettings;
}

export interface RentalApplicationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: RentalApplicationSettings;
  targets: OverrideTargetDto[];
}

export interface RentalApplicationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: RentalApplicationSettings;
  overrides: RentalApplicationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface RentalApplicationSettingsTypedSettingsOverrideEntryDocument {
  settings: RentalApplicationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

/** SetCompanySettingRequestDto */
export interface SetCompanySettingRequestDto {
  settings: any;
}

/** SetOverridesRequestDto */
export interface SetOverridesRequestDto {
  settings: any;
  targets: OverrideTargetDto[];
}

export interface SyndicationProvider {
  type: SyndicationType;
  active: boolean;
  extendedProperties?: Record<string, JsonNode>;
}

export interface SyndicationSettings {
  /**
   * @minLength 0
   * @maxLength 250
   */
  contactName?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  contactEmail?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  contactPhone?: string;
  providers: SyndicationProvider[];
}

export interface SyndicationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: SyndicationSettings;
}

export interface SyndicationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: SyndicationSettings;
  targets: OverrideTargetDto[];
}

export interface SyndicationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: SyndicationSettings;
  overrides: SyndicationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface SyndicationSettingsTypedSettingsOverrideEntryDocument {
  settings: SyndicationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface TemplateRef {
  kind: TemplateRefKind;
  /** @format int64 */
  id: string;
}

export interface TenantAutoPayFailedNotificationSettings {
  sendNotifyOnTenantAutoPayFailed: boolean;
  sendNotifyOnTenantAutoPayFailedViaText: boolean;
  sendNotifyOnTenantAutoPayFailedViaEmail: boolean;
}

export interface TenantAutoPayFailedNotificationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: TenantAutoPayFailedNotificationSettings;
}

export interface TenantAutoPayFailedNotificationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: TenantAutoPayFailedNotificationSettings;
  targets: OverrideTargetDto[];
}

export interface TenantAutoPayFailedNotificationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: TenantAutoPayFailedNotificationSettings;
  overrides: TenantAutoPayFailedNotificationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface TenantAutoPayFailedNotificationSettingsTypedSettingsOverrideEntryDocument {
  settings: TenantAutoPayFailedNotificationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface TenantPaymentReminderSettings {
  triggerOnPostedChartOfAccountIds?: string[];
  notifyOnPostedBalance: boolean;
  sendPostedBalanceNotificationsAsText: boolean;
  sendPostedBalanceNotificationsAsEmail: boolean;
  sendPostedBalanceNotificationsToEvictionLeases: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  postedBalanceNotificationEmailSubject: string;
  postedBalanceNotificationTextMessage: string;
  postedBalanceNotificationEmailMessage: string;
  notifyOnPaymentDue: boolean;
  sendPaymentDueNotificationsAsText: boolean;
  sendPaymentDueNotificationsAsEmail: boolean;
  sendPaymentDueNotificationsToEvictionLeases: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  paymentDueNotificationEmailSubject: string;
  paymentDueNotificationTextMessage: string;
  paymentDueNotificationEmailMessage: string;
  notifyOnPaymentOutstanding: boolean;
  sendPaymentOutstandingNotificationsAsText: boolean;
  sendPaymentOutstandingNotificationsAsEmail: boolean;
  sendPaymentOutstandingNotificationsToEvictionLeases: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  paymentOutstandingNotificationEmailSubject: string;
  paymentOutstandingNotificationTextMessage: string;
  paymentOutstandingNotificationEmailMessage: string;
  notifyOnPaymentPastDue: boolean;
  sendPaymentPastDueNotificationsAsText: boolean;
  sendPaymentPastDueNotificationsAsEmail: boolean;
  sendPaymentPastDueNotificationsToEvictionLeases: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  paymentPastDueNotificationEmailSubject: string;
  paymentPastDueNotificationTextMessage: string;
  paymentPastDueNotificationEmailMessage: string;
  notifyOnPaymentDelinquency: boolean;
  sendPaymentDelinquencyNotificationsAsText: boolean;
  sendPaymentDelinquencyNotificationsAsEmail: boolean;
  sendPaymentDelinquencyNotificationsToEvictionLeases: boolean;
  /**
   * @minLength 0
   * @maxLength 500
   */
  paymentDelinquencyNotificationEmailSubject: string;
  paymentDelinquencyNotificationTextMessage: string;
  paymentDelinquencyNotificationEmailMessage: string;
  /** @format int32 */
  notifyPaymentDelinquencyAfterXDays: number;
  /** @format double */
  minimumBalanceDueForNotification: number;
}

export interface TenantPaymentReminderSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: TenantPaymentReminderSettings;
}

export interface TenantPaymentReminderSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: TenantPaymentReminderSettings;
  targets: OverrideTargetDto[];
}

export interface TenantPaymentReminderSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: TenantPaymentReminderSettings;
  overrides: TenantPaymentReminderSettingsTypedSettingsOverrideEntryDocument[];
}

export interface TenantPaymentReminderSettingsTypedSettingsOverrideEntryDocument {
  settings: TenantPaymentReminderSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface TenantPortalInviteTextNotificationSettings {
  portalInviteMessage: string;
  portalPasswordChangeMessage: string;
}

export interface TenantPortalInviteTextNotificationSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: TenantPortalInviteTextNotificationSettings;
}

export interface TenantPortalInviteTextNotificationSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: TenantPortalInviteTextNotificationSettings;
  targets: OverrideTargetDto[];
}

export interface TenantPortalInviteTextNotificationSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: TenantPortalInviteTextNotificationSettings;
  overrides: TenantPortalInviteTextNotificationSettingsTypedSettingsOverrideEntryDocument[];
}

export interface TenantPortalInviteTextNotificationSettingsTypedSettingsOverrideEntryDocument {
  settings: TenantPortalInviteTextNotificationSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface TextSettings {
  enableTexts: boolean;
  includeAiTag: boolean;
  /**
   * @minLength 0
   * @maxLength 50
   */
  aiTag: string;
}

export interface TextSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: TextSettings;
}

export interface TextSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: TextSettings;
  targets: OverrideTargetDto[];
}

export interface TextSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: TextSettings;
  overrides: TextSettingsTypedSettingsOverrideEntryDocument[];
}

export interface TextSettingsTypedSettingsOverrideEntryDocument {
  settings: TextSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface TimeRange {
  /** @format date-span */
  start?: string;
  /** @format date-span */
  end?: string;
}

/** UpdateCustomViewDto */
export interface UpdateCustomViewDto {
  /** @minLength 1 */
  name: string;
  favorite: boolean;
  columns: CreateViewColumnDto[];
  description?: string;
}

/** UpdatePortalInviteTemplateDto */
export interface UpdatePortalInviteTemplateDto {
  name?: string;
  email: PortalInviteTemplateEmailDto;
  text: PortalInviteTemplateTextDto;
}

export interface ViewColumn {
  key: string;
  type: ColumnType;
  selected: boolean;
  /** @format int32 */
  displayOrder?: number;
  /** @format int32 */
  width?: number;
  /** @format int64 */
  customFieldId?: string;
  description?: string;
}

/** ViewColumnDto */
export interface ViewColumnDto {
  key: string;
  type: string;
  selected: boolean;
  /** @format int32 */
  displayOrder?: number;
  /** @format int32 */
  width?: number;
  customFieldId?: string;
  description?: string;
}

export interface WorkOrderSettings {
  sendVendorsTextMessageWhenAssigned: boolean;
  sendVendorsEmailMessageWhenAssigned: boolean;
  sendTenantVendorCoordinationMessage: boolean;
  /** @format int32 */
  recurringWorkOrderDaysInAdvance: number;
}

export interface WorkOrderSettingsCompanyPortalTypedSetCompanyRequestDocument {
  settings: WorkOrderSettings;
}

export interface WorkOrderSettingsCompanyPortalTypedSetOverridesRequestDocument {
  settings: WorkOrderSettings;
  targets: OverrideTargetDto[];
}

export interface WorkOrderSettingsCompanyPortalTypedSettingsWithOverridesDocument {
  settings: WorkOrderSettings;
  overrides: WorkOrderSettingsTypedSettingsOverrideEntryDocument[];
}

export interface WorkOrderSettingsTypedSettingsOverrideEntryDocument {
  settings: WorkOrderSettings;
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
  groupId?: string;
}

export interface CreateParams {
  type: CustomViewType;
}

export interface GetAllParams {
  type: CustomViewType;
}

export interface GetParams {
  type: CustomViewType;
  key: string;
}

export interface UpdateParams {
  type: CustomViewType;
  key: string;
}

export interface DeleteParams {
  type: CustomViewType;
  key: string;
}

export interface Update2Params {
  /** @format int64 */
  id: string;
}

export interface Delete2Params {
  /** @format int64 */
  id: string;
}

export interface ResetParams {
  /** @format int64 */
  id: string;
}

export interface GetSettingAchpaymentprocessingParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingAchpaymentprocessingParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingAgentschatParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingAgentschatParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingAssociationviolationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingAssociationviolationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingAutopayincentivesParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingAutopayincentivesParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingChargenotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingChargenotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingChataileaserenewalParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingChataileaserenewalParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingChataileaserentersinsuranceParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingChataileaserentersinsuranceParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingChataileaseParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingChataileaseParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingChataimaintenancerequestsParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingChataimaintenancerequestsParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingChataiParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingChataiParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingChataitranslationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingChataitranslationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingChatParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingChatParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingCommunicationsParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingCommunicationsParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingCompanyParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingCompanyParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingContributionParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingContributionParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingCustomviewParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingCustomviewParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingDepositpaymentParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingDepositpaymentParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingDistributionParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingDistributionParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingEmailParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingEmailParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingLatefeesParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingLatefeesParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingLeasechartofaccountParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingLeasechartofaccountParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingLeaseinvoiceParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingLeaseinvoiceParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingLeaserenewalParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingLeaserenewalParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingLeaserentersinsuranceParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingLeaserentersinsuranceParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingMaintenancerequestrunbookParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingMaintenancerequestrunbookParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingMaintenancerequestParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingMaintenancerequestParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingManagementfeeParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingManagementfeeParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingOutgoingpaymentsParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingOutgoingpaymentsParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingPropertymanagernotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingPropertymanagernotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingPropertyParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingPropertyParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentalapplicationbillingParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentalapplicationbillingParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentalapplicationchartofaccountParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentalapplicationchartofaccountParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentalapplicationgeneralParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentalapplicationgeneralParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentalapplicationpaymentaccountParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentalapplicationpaymentaccountParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentalapplicationpaymentParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentalapplicationpaymentParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentalapplicationquestionnaireParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentalapplicationquestionnaireParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentalapplicationscreeningParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentalapplicationscreeningParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentalapplicationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentalapplicationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentpaymentfailurefeeParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentpaymentfailurefeeParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentpaymentnotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentpaymentnotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentpaymentprocessingfeesParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentpaymentprocessingfeesParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingRentpaymentParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingRentpaymentParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingSyndicationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingSyndicationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingTenantautopayfailednotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingTenantautopayfailednotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingTenantpaymentreminderParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingTenantpaymentreminderParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingTenantportalinvitetextnotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingTenantportalinvitetextnotificationParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingTextParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingTextParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface GetSettingWorkorderParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveSettingWorkorderParams {
  level: SettingsLevel;
  /** @format int64 */
  levelId: string;
}

export interface RemoveGroupAchpaymentprocessingParams {
  groupId: string;
}

export interface RemoveGroupAgentschatParams {
  groupId: string;
}

export interface RemoveGroupAssociationviolationParams {
  groupId: string;
}

export interface RemoveGroupAutopayincentivesParams {
  groupId: string;
}

export interface RemoveGroupChargenotificationParams {
  groupId: string;
}

export interface RemoveGroupChataileaserenewalParams {
  groupId: string;
}

export interface RemoveGroupChataileaserentersinsuranceParams {
  groupId: string;
}

export interface RemoveGroupChataileaseParams {
  groupId: string;
}

export interface RemoveGroupChataimaintenancerequestsParams {
  groupId: string;
}

export interface RemoveGroupChataiParams {
  groupId: string;
}

export interface RemoveGroupChataitranslationParams {
  groupId: string;
}

export interface RemoveGroupChatParams {
  groupId: string;
}

export interface RemoveGroupCommunicationsParams {
  groupId: string;
}

export interface RemoveGroupCompanyParams {
  groupId: string;
}

export interface RemoveGroupContributionParams {
  groupId: string;
}

export interface RemoveGroupCustomviewParams {
  groupId: string;
}

export interface RemoveGroupDepositpaymentParams {
  groupId: string;
}

export interface RemoveGroupDistributionParams {
  groupId: string;
}

export interface RemoveGroupEmailParams {
  groupId: string;
}

export interface RemoveGroupLatefeesParams {
  groupId: string;
}

export interface RemoveGroupLeasechartofaccountParams {
  groupId: string;
}

export interface RemoveGroupLeaseinvoiceParams {
  groupId: string;
}

export interface RemoveGroupLeaserenewalParams {
  groupId: string;
}

export interface RemoveGroupLeaserentersinsuranceParams {
  groupId: string;
}

export interface RemoveGroupMaintenancerequestrunbookParams {
  groupId: string;
}

export interface RemoveGroupMaintenancerequestParams {
  groupId: string;
}

export interface RemoveGroupManagementfeeParams {
  groupId: string;
}

export interface RemoveGroupOutgoingpaymentsParams {
  groupId: string;
}

export interface RemoveGroupPropertymanagernotificationParams {
  groupId: string;
}

export interface RemoveGroupPropertyParams {
  groupId: string;
}

export interface RemoveGroupRentalapplicationbillingParams {
  groupId: string;
}

export interface RemoveGroupRentalapplicationchartofaccountParams {
  groupId: string;
}

export interface RemoveGroupRentalapplicationgeneralParams {
  groupId: string;
}

export interface RemoveGroupRentalapplicationpaymentaccountParams {
  groupId: string;
}

export interface RemoveGroupRentalapplicationpaymentParams {
  groupId: string;
}

export interface RemoveGroupRentalapplicationquestionnaireParams {
  groupId: string;
}

export interface RemoveGroupRentalapplicationscreeningParams {
  groupId: string;
}

export interface RemoveGroupRentalapplicationParams {
  groupId: string;
}

export interface RemoveGroupRentpaymentfailurefeeParams {
  groupId: string;
}

export interface RemoveGroupRentpaymentnotificationParams {
  groupId: string;
}

export interface RemoveGroupRentpaymentprocessingfeesParams {
  groupId: string;
}

export interface RemoveGroupRentpaymentParams {
  groupId: string;
}

export interface RemoveGroupSyndicationParams {
  groupId: string;
}

export interface RemoveGroupTenantautopayfailednotificationParams {
  groupId: string;
}

export interface RemoveGroupTenantpaymentreminderParams {
  groupId: string;
}

export interface RemoveGroupTenantportalinvitetextnotificationParams {
  groupId: string;
}

export interface RemoveGroupTextParams {
  groupId: string;
}

export interface RemoveGroupWorkorderParams {
  groupId: string;
}
